// External Dependencies
import FlatButton from 'material-ui/FlatButton';
import React, { Component } from 'react';
import firebase from 'firebase';
import { grey900 } from 'material-ui/styles/colors';
import { hashHistory } from 'react-router';

// Internal Dependencies
import { googleProvider } from '../config/constants';

// Component Definition
class LoginButton extends Component {
  handleLogin = () => {
    firebase.auth().signInWithPopup(googleProvider).then((result) => {
      if ((result.user.email).includes('call-em-all.com')) {
        hashHistory.push('/dashboard');
      }
    });
  }

  render() {
    return (
      <FlatButton
        className="Login"
        backgroundColor={grey900}
        hoverColor={grey900}
        onClick={this.handleLogin}
      >&nbsp;
      </FlatButton>
    );
  }
}

export default LoginButton;



/** WEBPACK FOOTER **
 ** ./src/app-main-container/login-button.js
 **/